import React, { useState, useContext, useEffect } from "react"
import { FiEdit3, FiCheck, FiX } from "react-icons/fi"
import UAI from "../UAI"
import "./Atributo.css"
import AtributoModal from "./AtributoModal"
import Loading from "../Utils/Loading"
import { UsuarioContext } from "../Context/Usuario"
import AtributoInput from "./AtributoInput"
import localforage from "localforage"
import log from "loglevel"

/**
 * Componente para mostrar un atributo y poder editarlo en caso de que el usuario tenga los permisos
 * @param {*} props
 */
const Atributo = (props) => {
  const { usuario, setUsuario } = useContext(UsuarioContext)

  const [isOpen, setIsOpen] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [value, setValue] = useState(null)
  const [valueMobile, setValueMobile] = useState(null)

  const onClickHandler = () => {
    setIsOpen(true)
  }

  const saveChanges = (newvalue) => {
    log.debug(props)
    log.debug(
      "Saving " +
        props.field.key +
        " from " +
        props.cohorte[props.field.key] +
        " to " +
        newvalue
    )
    setIsOpen(false)
    setValue(newvalue)
    setIsSaving(true)
    UAI.actualizaAtributo(
      usuario,
      props.cohorte.id,
      props.field.key,
      newvalue,
      saveAtributoSuccess,
      saveAtributoError
    )
  }

  const saveAtributoSuccess = (result) => {
    log.debug("Yeah! Saved!")
    log.debug(result)
    if (
      Array.isArray(result) &&
      result.length > 0 &&
      result[0].Solicitudes &&
      Array.isArray(result[0].Solicitudes) &&
      result[0].Solicitudes.length > 0
    ) {
      let errores = UAI.obtieneErroresActualizacionAtributosCohortes(result[0])
      if (errores) {
        log.debug(errores)
        saveAtributoError(errores)
      } else {
        log.debug(
          "Refrescando atributo " +
            props.field.key +
            " en período " +
            usuario.periodo
        )
        usuario.obtieneNuevosAtributosCohortes(
          [props.field.key],
          [usuario.periodo],
          (result) => {
            log.debug("OK! Ahora deberían estar modificado")
            log.debug(result)
            log.debug(usuario.cohortes[props.cohorte.id])
            setIsSaving(false)
          },
          (e) => {
            alert("Error!")
            log.error(e)
            setIsSaving(false)
          }
        )
      }
    } else {
      saveAtributoError("¡Resultado no contiene un arreglo de solicitudes!")
    }
  }

  const saveAtributoError = (error) => {
    log.error("Error guardando atributo")
    log.error(error)
    setIsSaving(false)
  }

  const cancel = () => {
    log.debug("Cancel changes")
    setIsOpen(false)
  }

  useEffect(() => {
    let _value = null
    let fieldIsFunction = false
    if (typeof props.field.display === "function") {
      _value = props.field.display(
        props.cohorte,
        usuario.periodo,
        props.highlight,
        usuario
      )
      fieldIsFunction = true
    } else if (props.cohorte[props.field.key] === null) {
      _value = ""
    } else if (props.highlight !== undefined) {
      _value = UAI.highlight(
        props.cohorte[props.field.key].toString(),
        props.highlight
      )
    } else {
      _value = props.cohorte[props.field.key]
        ? props.cohorte[props.field.key].toString()
        : undefined
    }

    if (
      _value !== null &&
      _value !== undefined &&
      props.field.Tipo === "TextoGrande"
    ) {
      if (!props.fullvalue) {
        _value = _value.length > 50 ? _value.substring(0, 50) + "..." : _value
      } else {
        _value = (
          <div
            className="atributoHtml"
            dangerouslySetInnerHTML={{
              __html: _value.split("\n").join("<br />"),
            }}
          ></div>
        )
      }
    }

    if (props.field.Tipo === "Html") {
      _value = (
        <div
          className="atributoHtml"
          dangerouslySetInnerHTML={{ __html: _value }}
        ></div>
      )
    } else if (props.field.Tipo === "Booleano" && !fieldIsFunction) {
      _value = _value ? <FiCheck /> : <FiX />
    }

    let _valuemobile =
      props.field.displaymobile !== undefined &&
      typeof props.field.displaymobile === "function"
        ? props.field.displaymobile(
            props.cohorte,
            usuario.periodo,
            props.highlight,
            usuario
          )
        : null

    setValue(_value)
    setValueMobile(_valuemobile)
  }, [props.cohorte, props.field, props.highlight, props.fullvalue, usuario])

  if (isSaving) {
    return (
      <div className="atributo">
        <Loading small />
      </div>
    )
  }

  if (props.inline) {
    return (
      <AtributoInput
        atributo={props.field}
        cohorte={props.cohorte}
        onChange={saveChanges}
      />
    )
  }

  return (
    <div className="atributo">
      {!isOpen && !props.field.editable && (
        <div className="atributo-valor">{value}</div>
      )}
      {!isOpen && props.field.editable && (
        <div className="atributo-editable">
          {valueMobile === null && (
            <div className="atributo-valor" onClick={onClickHandler}>
              {value}
            </div>
          )}
          {valueMobile !== null && (
            <div className="atributo-valor">
              <span className="d-none d-sm-block" onClick={onClickHandler}>
                {value}
              </span>
              <span className="d-sm-none" onClick={onClickHandler}>
                {valueMobile}
              </span>
            </div>
          )}
        </div>
      )}
      {isOpen && props.field.editable && (
        <AtributoModal
          cohorte={props.cohorte}
          field={props.field}
          isOpen={isOpen}
          name={props.field.key}
          Guardar={saveChanges}
          Cerrar={cancel}
        />
      )}
    </div>
  )
}

export default Atributo
